<script setup>
import { onMounted, computed } from 'vue';
import {Button} from '@components'; // Ensure the correct path to your Button component
import { useModal } from '@store/modal';
import { useTranslation } from '../composables/useTranslation';

const { t } = useTranslation();

const $modal = useModal();

const o = computed(() => $modal.getOptions);
const isOpen = computed(() => $modal.isOpen);

onMounted( () => {
  window.addEventListener('keydown', (e) => {

	// ESC key.
	if ( e.key === 'Escape' && isOpen.value && o.value.escClose ) {
	  $modal.close();
	}

  })
})
</script>

<template>

  <div class="formychat-modal fixed top-0 left-0 w-full h-full flex items-center justify-center" :class="{ 'z-[9999]': isOpen, '-z-10' : !isOpen }">
    <div v-if="isOpen" class="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 z-0" @click.prevent="o.outsideClick ? $modal.close() : null"></div>
    <transition name="bounce">
		<div v-if="isOpen" class="z-[9999] w-full max-w-lg bg-white p-4 lg:p-8 rounded-lg flex flex-col gap-4 relative">
			<button v-if="o.close" :title="t('close')" @click.prevent="$modal.close" class="absolute top-3 right-3 text-gray-500 hover:text-gray-800">
			  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
			  </svg>
			</button>
			<h3 class="font-semibold text-lg" v-if="o.title">{{ o.title }}</h3>
			<p class="text-[14px] text-gray-500" v-if="o.message" v-html="o.message"></p>
			<div class="flex items-center justify-end child:text-center gap-3 mt-4 child:px-6 child:font-medium child:py-2.5 child:rounded child-hover:opacity-95 child:transition " v-if="o.cancel || o.ok">
			  <Button :color="o.cancelColor" outline @click.prevent="$modal.cancel" v-if="o.cancel">{{ o.cancel }}</Button>
			  <Button :color="o.okColor" @click.prevent="$modal.ok" v-if="o.ok">{{ o.ok }}</Button>
			</div>
		  </div>
	</transition>
  </div>
</template>
